import React, { useState } from 'react';
import { Tabs } from 'antd';
import { ProfileOutlined, SettingOutlined, CreditCardOutlined } from '@ant-design/icons';
import Profile from '../Account Settings/Profile';
import GeneralSettings from '../Account Settings/Settings';
import SubscriptionBilling from '../Account Settings/Subscription';
import '../admin.css';

const AccountSettingsPage = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const items = [
    {
      key: 'profile',
      label: (
        <span>
          <ProfileOutlined />
          Profile
        </span>
      ),
      children: <Profile />,
    },
    {
      key: 'general',
      label: (
        <span>
          <SettingOutlined />
          Settings
        </span>
      ),
      children: <GeneralSettings />,
    },
    {
      key: 'subscription',
      label: (
        <span>
          <CreditCardOutlined />
          Subscription & Billing
        </span>
      ),
      children: <SubscriptionBilling />,
    },
  ];

  return (
    <div className="abo-content">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
        style={{ marginBottom: 24 }}
      />
    </div>
  );
};

export default AccountSettingsPage;
